import { Component, OnInit, NgZone, HostListener } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MainAppComponent } from '../../../layout/layout.component';
import { CharacteristicModel } from '../../../common/viewModels/GlobalRegistry/CharacteristicsModel';
import { SampleModel } from '../../../common/viewModels/Analysis/SampleModel';
import { FerroGraphyImages } from '../../../common/viewModels/Analysis/SampleModel';
import { AnalysisElementSectionTypeModel } from '../../../common/viewModels/Analysis/SampleModel';
import { SampleTypesEnum } from '../../../common/enumcontainer.enum';
import { RecommendationModal } from '../../../common/viewModels/GlobalRegistry/UnitsModel';
import 'rxjs/add/operator/map';
declare var $: any;

@Component({
    selector: 'ferrographysampleresults',
    templateUrl: './ferrographysampleresults.component.html',
    styleUrls: ['./ferrographysampleresults.component.scss']
})
export class AddFerroGraphySampleResults implements OnInit {
    addeditferroresults: FormGroup;
    lstAnalysisSections: AnalysisElementSectionTypeModel[];
    sample: SampleModel = new SampleModel();
    characteristics: CharacteristicModel[];
    lstResultTypes: any;
    id: number;
    isFormValid: boolean = true;
    ratingId: any[];
    fileErrorMsg: boolean = false;
    hasImageFile: boolean = false;
    ferroFileName: any;
    ferroFile: FerroGraphyImages = new FerroGraphyImages();
    ferroFiles: FerroGraphyImages[];
    ferroImgs: any[];
    imageFile: FormData = new FormData();
    baseUrl: string;
    imageId: number;
    lstRecommendations: RecommendationModal[];
    lstRecommendations1: RecommendationModal[];

    ckeState: {
        [key: string]: {
            show: boolean;
            filtered: RecommendationModal[];
        };
    } = {
            Recommendation: {
                show: false,
                filtered: [],
            },

            Recommendation2: {
                show: false,
                filtered: [],
            },
        };

    quillConfig = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ color: [] }, { background: [] }],
        ],
    };

    constructor(
        public _router: Router,
        private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl,
        private _route: ActivatedRoute,
        private _mApp: MainAppComponent,
        private _toastrService: ToastrService,
        private ngZone: NgZone
    ) { }

    ngOnInit() {
        this.id = this._route.snapshot.params['id'];
        this.GetListOfSectionChars(this.id);
        this.baseUrl = this._appUrl.baseUrl;
        this.GetFerroGraphyResultTypes();
        this.addeditferroresults = this._formBuilder.group({
            SampleId: [''],
            Recommendation: [''],
            Recommendation2: [''],
            WpConcentration: [''],
            Dl: [''],
            Ds: [''],
            Plp: [''],
            AllowableWpcLimit: [''],
            Gw: [''],
            GwSize: [''],
            Bw: [''],
            BwSize: [''],
            Sw: [''],
            SwSize: [''],
            CuAlloy: [''],
            CuAlloySize: [''],
            BabbitBw: [''],
            BabbitBwSize: [''],
        })
        this.GetRecommendationsMinInfoList();
    }

    GetFerroGraphyResultTypes() {
        this._http.get(this._appUrl.GetMinInfoFerroGraphyResultTypes)
            .subscribe(
                data => {
                    this.lstResultTypes = data.json().Result;
                },
                error => {
                    this._toastrService.error("Error occured", '')
                }
            )
    }

    MakeGradeMand(id) {
        if (this.ratingId.filter(m => m != id))
            this.ratingId.push(id);
    }

    ShowErrorMsg(id) {
        for (let item of this.ratingId) {
            if (id == item) {
                return true;
            }
        }
        return false;
    }
    RemoveValidation(id, val) {
        // if(val.value>0)
        //   this.ratingId.r
    }

    GetListOfSectionChars(id) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetListOfSectionCharsForFerrography + id)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    if (data.json().Result != null) {

                        this.sample = data.json().Result;
                        this.lstAnalysisSections = this.sample.LstAnalysis;
                        this.ferroFiles = this.sample.FerroFileImages;
                        //this.ferroImgs = this.sample.FerroFileImages;
                        this.GetFerroGraphyResultsBySampleId(id);
                    }
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetFerroGraphyResultsBySampleId(id) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetFerroGraphyResultsBySampleId + id)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    if (data.json().Result != null) {
                        this.addeditferroresults.setValue(data.json().Result);
                    }
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    CheckValidity(lst: any) {
        for (let i = 0; i < lst.length; i++) {
            for (let j = 0; j < lst[i].LstAnalysisElements.length; j++) {
                if (lst[i].LstAnalysisElements[j].SampleRsltDetails.TestRatingId == undefined)
                    lst[i].LstAnalysisElements[j].SampleRsltDetails.TestRatingId = 0;
                if (lst[i].LstAnalysisElements[j].SampleRsltDetails.Result != null && lst[i].LstAnalysisElements[j].SampleRsltDetails.Result.length > 0 && parseInt(lst[i].LstAnalysisElements[j].SampleRsltDetails.TestRatingId) == 0) {
                    this.isFormValid = false;
                    return;
                }
                else {
                    this.isFormValid = true;
                }
            }
        }
    }

    OnSubmit(IsSaveNext) {

        if (this.isFormValid) {
            this._mApp.ShowLoader();
            this.sample.FerroResults = this.addeditferroresults.value;
            this.sample.FerroFileImages = [];
            if (this.ferroFiles != undefined && this.ferroFiles != null && this.ferroFiles.length > 0) {
                for (let item of this.ferroFiles) {
                    this.sample.FerroFileImages.push({
                        ImageId: item.ImageId,
                        SampleId: item.SampleId,
                        Path: item.Path,
                        FileName: item.FileName,
                        Description: item.Description
                    });
                }
            }
            this._http.post(this._appUrl.UpsertFerroGraphyResultsDetails, this.sample)
                .subscribe(
                    data => {
                        this._mApp.HideLoader();
                        this._toastrService.success(data.json().Result, '')
                        if (IsSaveNext)
                            this._router.navigate(['/approveferroresults', this.id])
                        else
                            this._router.navigate(['/samplestatus']);
                    }, error => {

                        this._mApp.HideLoader();
                        this._toastrService.error(error.json().Result, '')
                    }
                )
        }
    }

    uploadImage(event: any) {
        this.imageFile = new FormData();
        //this.ferroFiles = [];
        var element = ((window.event) ? (event.srcElement) : (event.currentTarget));
        var srcElement = event.srcElement || event.target;
        var files = srcElement.files;
        var size = files[0].size;
        let formData = new FormData();
        this.hasImageFile = true;

        let ferroReportImages = this.ferroFiles.filter(m => m.ImageId > 0);
        if (!(ferroReportImages.length + files.length > 4)) {
            for (let i = 0; i < files.length; i++) {
                var ext = files[i].name.split('.').reverse()[0].toLowerCase();
                if (ext == "jpeg" || ext == "png" || ext == "gif" || ext == "jpg" || ext == "bmp") {
                    this.imageFile.append("uploads[]", files[i], files[i].name);
                    var fileName = files[i].name.split('.').slice(0, -1).join('.');

                }
                else {
                    this._toastrService.error("Please upload image files only");
                    $("#fileUploadImg").val('');
                    break;
                }
            }
            this.UploadSubmit(this.imageFile);
        }
        else {
            this._toastrService.error("You cannot upload more than 4 images for a sample.");
            $("#fileUploadImg").val('');
        }
    }

    UploadSubmit(imageFile) {
        this._mApp.ShowLoader();
        this._http.postUpload(this._appUrl.UploadFile, imageFile)
            .subscribe(
                data => {

                    this._mApp.HideLoader();
                    this.ferroFiles = this.ferroFiles;
                    let respo = data.json().Result;
                    if (this.ferroFiles.length >= 4) {
                        let index = this.ferroFiles.findIndex(m => m.ImageId == 0);
                        if (index != undefined && index >= 0 && index != null)
                            this.ferroFiles.splice(index, 1);
                    }
                    for (let item of respo) {
                        this.ferroFiles.push({
                            ImageId: item.ImageId,
                            SampleId: item.SampleId,
                            Path: item.Path,
                            FileName: item.FileName,
                            Description: item.Description
                        });
                    }
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            );
    }

    DeleteImage(id) {
        this.imageId = id;
    }

    DeleteFerrographyImage(imageId) {

        this.sample.FerroFileImages = this.sample.FerroFileImages.filter(function (item) { item.ImageId != imageId });
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteFerrographyImage + imageId)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this._toastrService.success(data.json().Result);
                    this.GetFerrographyImagesbySampleId(this.id);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    GetFerrographyImagesbySampleId(id) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetFerrographyImagesbySampleId + id)
            .subscribe(
                data => {

                    this._mApp.HideLoader();
                    //this.ferroImgs = data.json().Result;
                    this.ferroFiles = data.json().Result;
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            )
    }


    GetRecommendationsMinInfoList() {
        this._http.get(this._appUrl.GetRecommendationsMinInfoList + SampleTypesEnum.ferroGraphy)
            .subscribe(
                data => {
                    if (data.json().Result != null) {
                        this.lstRecommendations = data.json().Result;
                        this.lstRecommendations1 = data.json().Result;
                    }
                },
                error => {
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    filterRecommendation(val) {

        this.lstRecommendations1 = this.lstRecommendations.filter(m => m.Recommendation.toLowerCase().indexOf(val.toLowerCase()) === 0);

    }

    displayFn(rec) {
        return rec;
    }

    AutoPopulateWpcandPLPValues() {
        let dl = this.addeditferroresults.controls['Dl'].value;
        let ds = this.addeditferroresults.controls['Ds'].value;

        if ($.isNumeric(dl) && $.isNumeric(ds)) {
            dl = parseFloat(dl);
            ds = parseFloat(ds);
            let wpc = (dl + ds).toFixed(2);
            let plp = (((dl - ds) / (dl + ds)) * 100).toFixed(2);
            this.addeditferroresults.controls['WpConcentration'].setValue(wpc);
            this.addeditferroresults.controls['Plp'].setValue(plp);

        }
        else {
            this.addeditferroresults.controls['WpConcentration'].setValue(null);
            this.addeditferroresults.controls['Plp'].setValue(null);
        }
    }

    onEditorCreated(quill: any, controlName: string) {
        quill.root.addEventListener('focus', () => {
            this.ngZone.run(() => {
                this.filterQuillDropdown(controlName);
            });
        });

        quill.root.addEventListener('click', () => {
            this.ngZone.run(() => {
                this.filterQuillDropdown(controlName);
            });
        });
    }

    onQuillChanged(event: any, controlName: string) {
        this.ngZone.run(() => {
            this.filterQuillDropdown(controlName);
        });
    }

    filterQuillDropdown(controlName: string) {
        Object.keys(this.ckeState).forEach((key) => {
            if (key !== controlName) {
                this.ckeState[key].show = false;
            }
        });

        const state = this.ckeState[controlName];
        const control = this.addeditferroresults.get(controlName);
        const value = control ? control.value : '';
        const text = this.stripHtml(value).trim();
        if (this.lstRecommendations && this.lstRecommendations.length > 0) {
            if (!text) {
                state.filtered = this.lstRecommendations.slice();
            }
            else {
                state.filtered = this.lstRecommendations.filter(
                    x =>
                        x.Recommendation &&
                        x.Recommendation.toLowerCase().indexOf(text.toLowerCase()) !== -1
                );
            }
            state.show = state.filtered.length > 0;
        }
        else {
            state.filtered = [];
            state.show = false;
        }
    }

    selectQuillRecommendation(item: RecommendationModal, controlName: string): void {
        this.addeditferroresults.patchValue({
            [controlName]: item.Recommendation,
        });
        this.ckeState[controlName].show = false;
        this.ckeState[controlName].filtered = [];
    }

    private stripHtml(html: string): string {
        if (!html) {
            return '';
        }
        return html
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/g, ' ')
            .trim();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: any): void {
        this.ngZone.run(() => {
            const target = event.target;
            const clickedInsideEditor =
                target.closest('.ql-editor') ||
                target.closest('.ql-toolbar') ||
                target.closest('.cke-autocomplete-panel');
            if (!clickedInsideEditor) {
                Object.keys(this.ckeState).forEach((key) => {
                    this.ckeState[key].show = false;
                });
            }
        });
    }
}
